import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.page.html',
  styleUrls: ['./about-us.page.scss'],
})

export class AboutUsPage implements OnInit {

  releaseVersion: string;
  releaseDate: string;

  constructor(
    private http: HttpClient,
    private dialogRef: MatDialogRef<AboutUsPage>,
    @Inject(MAT_DIALOG_DATA) public data: AboutUsPage,
  ) {}
  

  ngOnInit() {
    this.http.get('assets/release.json').subscribe((res: any) => {
      this.releaseVersion = res.release_version;
      this.releaseDate = res.release_date;
    });
  }

  closeModal() {
    this.dialogRef.close();
  }
}  